import logo from "../../../../assets/users/transparent.png";
import qr from "../../../../assets/users/qr.jpg";
import "./style.scss";
import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaTwitter,
  FaPinterest,
  FaSkype,
} from "react-icons/fa";

import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer_area section_padding_130_0 mt-5">
      <div className="container">
        <div className="row">
          {/* Logo and Description */}
          <div className="col-12 col-sm-6 col-lg-4">
            <div className="single-footer-widget section_padding_0_130">
              <div className="footer-logo mb-3">
                <img src={logo} alt="Logo" className="footer-logo-img" />
              </div>
              <p style={{ color: "white" }}>
                VOVIBOOK là nơi mang đến cho bạn những cuốn sách quý, phong phú
                và đa dạng.
              </p>
              <div className="copywrite-text mb-5">
                <p className="mb-0">
                  Made with <i className="lni-heart mr-1"></i>by VOVIBOOK
                </p>
              </div>
              <div className="footer_social_area">
                <a href="#" title="Facebook">
                  <FaFacebook />
                </a>
                <a href="#" title="Instagram">
                  <FaInstagram />
                </a>
                <a href="#" title="Youtube">
                  <FaYoutube />
                </a>
                <a href="#" title="Pinterest">
                  <FaPinterest />
                </a>
                <a href="#" title="Skype">
                  <FaSkype />
                </a>
                <a href="#" title="Twitter">
                  <FaTwitter />
                </a>
              </div>
            </div>
          </div>

          {/* About Section */}
          <div className="col-12 col-sm-6 col-lg">
            <div className="single-footer-widget section_padding_0_130">
              <h5 className="widget-title">Về VOVIBOOK</h5>
              <div className="footer_menu">
                <ul>
                  <li>
                    <a href="#">Giới thiệu</a>
                  </li>
                  <li>
                    <a href="#">Tuyển dụng</a>
                  </li>
                  <li>
                    <a href="#">Blog</a>
                  </li>
                  <li>
                    <a href="#">Cộng đồng</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Support Section */}
          <div className="col-12 col-sm-6 col-lg">
            <div className="single-footer-widget section_padding_0_130">
              <h5 className="widget-title">Hỗ trợ</h5>
              <div className="footer_menu">
                <ul>
                  <li>
                    <a href="#">Trung tâm trợ giúp</a>
                  </li>
                  <li>
                    <Link to ="/privacy-policy">Chính sách bảo mật</Link>
                  </li>
                  <li>
                    <a href="#">Điều khoản</a>
                  </li>
                  <li>
                    <a href="#">Liên hệ hỗ trợ</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Contact Section */}
          <div className="col-12 col-sm-6 col-lg">
            <div className="single-footer-widget section_padding_0_130">
              <h5 className="widget-title">Liên hệ</h5>
              <div className="footer_menu">
                <ul>
                  <li>
                    <a href="#">Trung tâm hỗ trợ</a>
                  </li>
                  <li>
                    <a href="#">Gửi email cho chúng tôi</a>
                  </li>
                  <li>
                    <a href="#">Điều khoản dịch vụ</a>
                  </li>
                  <li>
                    <a href="#">Trung tâm giúp đỡ</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
